import React, { useState, createContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ExecuteAxios from "../Components/ExecuteAxios/ExecuteAxios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [authenticated, setAuthenticated] = useState(false);
    const [clientList, setClientList] = useState(null);
    const [clientSelected, setClientSelected] = useState(null);
    const [clientSelectedHandled, setClientSelectedHandled] = useState(false);
    const prevClientSelectedRef = useRef();

    useEffect(() => {
        if (authenticated) {
            validateClientList();
        }
    }, [authenticated]);

    useEffect(() => {
        if (prevClientSelectedRef.current !== clientSelected) {
            localStorage.setItem('selectedClientId', clientSelected);
            setClientSelectedHandled(true);
            prevClientSelectedRef.current = clientSelected;
        }
    }, [clientSelected]);


    async function validateClientList() {
        const options = await ExecuteAxios.api('get', '/client/get-client-lookup/');
        setClientList(options);

        const savedClientId = localStorage.getItem('selectedClientId');

        const stillExists = options.find(option => option.id == savedClientId);

        if (stillExists) {
            setClientSelected(savedClientId);
        } else if (options && options.length > 0) {
            setClientSelected(options[0].id);
        } else {
            setClientSelected(null);
        }
    }

    useEffect(() => {
        validateIam().then(async user => {
            if (!user) {
                setUser(null);
                setAuthenticated(false);
                return;
            }

            setUser({
                id: user.id,
                username: user.username,
                email: user.email,
                name: user.name
            });
            setAuthenticated(true);
            setLoading(false);
            navigate('/condominium');
        });
    }, []);

    async function validateIam() {
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: '/api/condbot/authenticator/iam',
                withCredentials: true
            };
            const authenticatedData = await axios.request(config);

            if (authenticatedData && authenticatedData.data && authenticatedData.data.email) {
                const parameters = {
                    email: authenticatedData.data.email.replace(/\s/g, "")
                }
                return await ExecuteAxios.api('get', `/user/get-user-by-email`, { params: parameters })
            } else return null;
        } catch (error) {
            setLoading(false);
        }
    }

    const login = async (email, password) => {
        try {
            let data = JSON.stringify({
                email: email,
                password: password
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: '/api/condbot/authenticator/login',
                data: data,
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            await axios.request(config);
            const user = await validateIam();

            if (user) {
                navigate("/condominium");
                setUser({
                    id: user.id,
                    username: user.username,
                    email: user.email,
                    name: user.name
                });
                setAuthenticated(true);
                localStorage.removeItem('selectedClientId');
            } else {
                setUser(null);
                setAuthenticated(false);
            }
        } catch (error) {
            setUser(null);
            setAuthenticated(false);
        }
    };

    const logout = async () => {
        localStorage.removeItem('selectedClientId');
        localStorage.removeItem("allowedScreens");
        await axios.post('/api/condbot/authenticator/logout');
        setUser(null);
        setAuthenticated(false);
        navigate("/login");
    };

    const createAccount = async (parameters) => {
        try {
            const response = await ExecuteAxios.api('post', `/user/create-account`, parameters);

            console.log(response)
            if (response == 'CREATED') {
                alert("Cadastrado com sucesso!");
                navigate("/");
            }
        } catch (error) {
            console.error(error);
            alert("Erro ao cadastrar usuário");
        }
    };

    return (
        <AuthContext.Provider
            value={{
                authenticated,
                user,
                loading,
                login,
                logout,
                clientList,
                validateClientList,
                clientSelected,
                setClientSelected,
                clientSelectedHandled,
                setClientSelectedHandled,
                createAccount
            }}>
            {children}
        </AuthContext.Provider >
    );

};